import classNames from "classnames";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import useBreakpoints from "hooks/useBreakpoints";
import { useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { featureTrackerAPI, offersApi } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import { ggItemsV2 } from "./items";
import {
	Alignment,
	Background,
	Body,
	Container,
	Copy,
	Footer,
	Head,
	Note
} from "./styles";
import { orderBy } from "lodash";
import { Carousel } from "./lib/Carousel";
import { Grid } from "./lib/Grid";

interface CGGMoreInfoProps {}

export const CGGMoreInfo: React.FC<CGGMoreInfoProps> = () => {
	const dispatch = useDispatch();
	const { isSmDown } = useBreakpoints();
	const { getImage } = useImagePath("cdn");
	const background = getImage(
		clubGiftsGaloreAssets.v2.popups.moreInfo.background
	);
	const { authToken, store } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const scale = useCalculateScale(isSmDown ? 458 : 1060, 576);

	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const { data: boxesData } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "clubGift",
		isAuthenticated: !!authToken?.value
	});

	const orderedOffers = orderBy(boxesData?.offers, ["priority"], ["asc"]);

	const giftBox = store?.clubGifts?.find(
		(gift) => gift.id === orderedOffers?.[0]?.id
	);

	const boxDescription = orderedOffers?.[0]?.description ?? "";
	const boxImageUrl = giftBox?.chestIconImageUrl ?? "";

	const items = ggItemsV2.map((item) => ({
		...item,
		title: item.title.replaceAll("[box_name]", boxDescription),
		image2: item.image2?.replaceAll("[box_url]", boxImageUrl)
	}));

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		if (data?.tracker?.clubGiftId) {
			// duplicated analytic in the info button click
			reportEvent("learn_more_clicked", {
				source: "club_gifts_galore",
				club_gifts_galore_id: data.tracker.clubGiftId
			});
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "learn_more_clicked",
				event_type: "club_gift_galore_v2",
				action: "learn_more_clicked",
				source: "club_gifts_galore",
				event_id: data.tracker.clubGiftId
			});
		}
	}, [data?.tracker?.clubGiftId]);

	return (
		<Container scale={scale} className={classNames(isSmDown && "mobile")}>
			<Head className="head">
				<Background src={background} />
			</Head>
			<CloseIconButton onClose={onClose} />
			<Alignment className="alignment">
				<Body>
					{isSmDown ? <Carousel items={items} /> : <Grid items={items} />}
				</Body>
				<Footer>
					<Copy className="copy">
						<Note className="note">Please Note:</Note>
						Each Tier has a set personal contribution limit for members.
						<br />
						Rewards are granted only for the Tiers unlocked while you are a
						member of the Club.
					</Copy>
				</Footer>
			</Alignment>
		</Container>
	);
};
